import React from "react";
import { Mail, User, Phone, Building2 } from "lucide-react";

import { FormInput } from "../form/FormInput";
import { FormSelect } from "../form/FormSelect";
import { FormDateInput } from "../form/FormDateInput";
import { FormPasswordInput } from "../form/FormPasswordInput";
import { Button } from "../../admin/components/button/Button";

import { FormData, FormErrors } from "../../types/types";

interface AcceptInviteFormFieldsProps {
  formData: FormData;
  errors: FormErrors;
  showPassword: boolean;
  showConfirmPassword: boolean;
  isSubmitting: boolean;
  isFormValid: boolean;
  today: string;
  handleChange: (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => void;
  togglePassword: () => void;
  toggleConfirmPassword: () => void;
  handleSubmit: (e: React.FormEvent) => void;
}

const AcceptInviteFormFields: React.FC<AcceptInviteFormFieldsProps> = ({
  formData,
  errors,
  showPassword,
  showConfirmPassword,
  isSubmitting,
  isFormValid,
  today,
  handleChange,
  togglePassword,
  toggleConfirmPassword,
  handleSubmit,
}) => {
  return (
    <form onSubmit={handleSubmit} className="space-y-4" noValidate>
      <FormInput
        label="Full Name"
        name="name"
        value={formData.name}
        onChange={handleChange}
        placeholder="John Doe"
        icon={<User className="h-4 w-4 text-gray-400" />}
        error={errors.name}
        required
      />

      <FormInput
        label="Email"
        name="email"
        value={formData.email}
        onChange={() => {}}
        type="email"
        icon={<Mail className="h-4 w-4 text-gray-400" />}
        readOnly
      />

      <FormInput
        label="Phone Number"
        name="phone"
        value={formData.phone}
        onChange={handleChange}
        placeholder="08011223344"
        type="tel"
        icon={<Phone className="h-4 w-4 text-gray-400" />}
        error={errors.phone}
        maxLength={11}
        required
      />

      <div className="grid grid-cols-2 gap-4">
        <FormSelect
          label="Gender"
          name="gender"
          value={formData.gender}
          onChange={handleChange}
          error={errors.gender}
          required
        >
          <option value="">Select</option>
          <option value="M">Male</option>
          <option value="F">Female</option>
        </FormSelect>

        <FormDateInput
          label="Date of Birth"
          name="dob"
          value={formData.dob}
          onChange={handleChange}
          error={errors.dob}
          max={today}
          required
        />
      </div>

      <FormInput
        label="Company"
        name="company"
        value={formData.company}
        onChange={handleChange}
        placeholder="Your company name"
        icon={<Building2 className="h-4 w-4 text-gray-400" />}
        error={errors.company}
        required
      />

      <FormPasswordInput
        label="Password"
        name="password"
        value={formData.password}
        onChange={handleChange}
        placeholder="Create a password"
        error={errors.password}
        showPassword={showPassword}
        togglePassword={togglePassword}
        required
      />

      <FormPasswordInput
        label="Confirm Password"
        name="password_confirmation"
        value={formData.password_confirmation}
        onChange={handleChange}
        placeholder="Confirm your password"
        error={errors.password_confirmation}
        showPassword={showConfirmPassword}
        togglePassword={toggleConfirmPassword}
        required
      />

      {errors.server && (
        <p className="text-sm text-red-600 text-center">{errors.server}</p>
      )}

      <Button
        type="submit"
        disabled={isSubmitting || !isFormValid}
        loading={isSubmitting}
      >
        Accept Invitation
      </Button>
    </form>
  );
};

export default AcceptInviteFormFields;
